import { requestHelpers } from '../../helpers';

const actions = {
    GET_MARKETS: "GET_MARKETS",
    SET_MARKETS: "SET_MARKETS",
};

function getMarkets() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_MARKETS,
        } );

        requestHelpers
            .authenticatedGetRequest( '/common/markets' )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_MARKETS,
                    markets: response.data,
                } );
            } );
    };
}

module.exports = {
    actions,
    getMarkets
}



// WEBPACK FOOTER //
// src/client/actions/common/markets.js